import { WORK_RIGHTS_AU_FIELDS } from '@/core/field-names';
import { WorkRightsFieldErrors } from '@/core/validation/field-errors';
import { isEmptyObject, isEmptyFileValue } from '@/lib/is-empty-object';

const MAX_FILE_SIZE = 10 * 1024 * 1024; // 10MB
function validateFile(fileValue) {
  if (fileValue?.sizeInBytes >= MAX_FILE_SIZE) {
    return WorkRightsFieldErrors.ExceedsFileSize;
  }
  return '';
}

function validatePassport(field) {
  if (!field.fileValue || isEmptyFileValue(field.fileValue)) {
    return WorkRightsFieldErrors.EmptyPassport;
  }
  return validateFile(field.fileValue);
}

function validateBirthCertificate(field) {
  if (!field.fileValue || isEmptyObject(field.fileValue)) {
    return WorkRightsFieldErrors.EmptyBirthCertificate;
  }

  return validateFile(field.fileValue);
}

function validatePhotoId(field) {
  if (!field.fileValue || isEmptyFileValue(field.fileValue)) {
    return WorkRightsFieldErrors.EmptyPhotoId;
  }
  return validateFile(field.fileValue);
}

export async function validateWorkRights(field) {
  switch (field.name) {
    case WORK_RIGHTS_AU_FIELDS.RESIDENCY:
      if (!field.value) {
        return WorkRightsFieldErrors.EmptyResidency;
      }
      break;
    case WORK_RIGHTS_AU_FIELDS.DOC_TYPE:
      if (field.appliedRules.visible && !field.value) {
        return WorkRightsFieldErrors.EmptyDocType;
      }
      break;
    case WORK_RIGHTS_AU_FIELDS.BIRTH_CERTIFICATE:
      if (field.appliedRules.visible) {
        return validateBirthCertificate(field);
      }
      break;
    case WORK_RIGHTS_AU_FIELDS.PHOTO_ID:
      if (field.appliedRules.visible) {
        return validatePhotoId(field);
      }
      break;
    case WORK_RIGHTS_AU_FIELDS.PASSPORT_NUMBER:
      if (field.appliedRules.visible && !field.value) {
        return WorkRightsFieldErrors.EmptyPassportNumber;
      }
      break;
    case WORK_RIGHTS_AU_FIELDS.PASSPORT:
      if (field.appliedRules.visible) {
        return validatePassport(field);
      }
      break;
    case WORK_RIGHTS_AU_FIELDS.COUNTRY_OF_DOCUMENT:
      if (field.appliedRules.visible && !field.value) {
        return WorkRightsFieldErrors.EmptyCountryOfDocument;
      }
      break;
    case WORK_RIGHTS_AU_FIELDS.TERMS_AND_CONDITIONS:
      if (field.appliedRules.visible && !field.value) {
        return WorkRightsFieldErrors.EmptyTermsAndConditions;
      }
      break;
  }
  return '';
}
